import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { outlinedButtonSx } from '../../theme/theme';

interface EditAppButtonProps {
  text: string;
  size?: 'small' | 'medium' | 'large';
  startIcon?: React.ReactNode;
  onClick?: () => void;
}

const StyledButton = styled(Button)(() => ({
  fontFamily: 'IRANYekanXFaNum',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'none',
  width: '134px',
  height: '30px',
  padding: '2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  ...outlinedButtonSx,
  '@media (max-width: 768px)': {
    width: '100%',
    fontSize: '12px',
    mt: '3px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    gap: '8px',
  },
}));

const EditAppButton: React.FC<EditAppButtonProps> = ({
  text,
  size = 'medium',
  startIcon,
  onClick,
}) => {
  return (
    <StyledButton size={size} startIcon={startIcon} onClick={onClick}>
      {text}
    </StyledButton>
  );
};

export default EditAppButton;
